import { useEffect, useRef } from "react";

import { useAppSelector } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";
import { selectAppliedViewpoint } from "slices/explorer";

/**
 * Emits a viewpointChanged event when the applied viewpoint changes.
 * Viewpoint can be changed either to a newly applied viewpoint or to null when user starts interacting with the viewer,
 * this allows the user to find out when the viewer state no longer represents earlier applied viewpoint.
 */
export function useNotifyAppliedViewpoint() {
    const {
        state: { internalEventEmitter },
    } = useExplorerGlobals();
    const appliedViewpoint = useAppSelector(selectAppliedViewpoint);
    const prevAppliedViewpointRef = useRef<typeof appliedViewpoint | null>(null);

    useEffect(() => {
        // Skip first event by checking that prevAppliedViewpointRef is not null
        if (internalEventEmitter && prevAppliedViewpointRef.current) {
            internalEventEmitter.emit("viewpointChanged", {
                viewpoint: appliedViewpoint.viewpoint,
                prevViewpoint: prevAppliedViewpointRef.current?.viewpoint ?? null,
                appliedBy: appliedViewpoint.appliedBy,
            });
        }
        prevAppliedViewpointRef.current = appliedViewpoint;
    }, [appliedViewpoint, internalEventEmitter]);
}
